import { LinkRollfiUser } from '../../../domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteLinkRollfiUser extends BaseHttpService<LinkRollfiUser.Model> implements LinkRollfiUser {
  async linkRollfiUser(body: LinkRollfiUser.Params): Promise<LinkRollfiUser.Model> {
    return await this.request('post', body);
  }
}
